import React from 'react';
import { Grid } from '@mui/material';
import PageTitle from 'components/header/PageTitle';
import CommonItemForm from 'components/common/CommonItemForm';

/* সার্বিক সহযোগিতায় — shown in the mobile app drawer; stored in the `sponsor` common item */
const SponsorPage = () => (
    <div>
        <PageTitle color="primary.main" title="সার্বিক সহযোগিতায়" />
        <Grid container spacing={3} sx={{ mt: 1, px: { xs: 1, md: 2 } }}>
            <Grid item xs={12} md={6}>
                <CommonItemForm
                    title="সার্বিক সহযোগিতায়"
                    itemKey="sponsor"
                    fields={[
                        { name: 'heading', label: 'Company Name' },
                        { name: 'phone', label: 'Phone Number' },
                        { name: 'email', label: 'Email Address' },
                        { name: 'url', label: 'Web Address' },
                    ]}
                />
            </Grid>
        </Grid>
    </div>
);

export default SponsorPage;
